import { GOAL_CATEGORY_TABLE_CONFIG } from '../config/goalCategoryTableConfig';
import { GOALS_TABLE_COLUMN_CONFIG } from '../config/goalsTableColumnConfig';
import { GOAL_TYPE_CONFIG } from '../config/goalTypeConfig';
import { AVERAGE_TIME_BASED_GOALS, DEFAULT_GOAL_REQUEST_SORTS } from '../constants/goals';
export const getIsAverageTimeBasedGoal = goalType => goalType && AVERAGE_TIME_BASED_GOALS.includes(goalType);
export const getGoalTargetRequestSorts = (selectedSortDirection, selectedSortColumn) => {
  const defaultSorts = DEFAULT_GOAL_REQUEST_SORTS;
  if (!selectedSortColumn || !selectedSortDirection) return defaultSorts;
  return [{
    property: GOALS_TABLE_COLUMN_CONFIG[selectedSortColumn].property,
    order: selectedSortDirection
  }];
};
export const getColumnsForGoalType = goalType => {
  const goalTypeConfig = GOAL_TYPE_CONFIG[goalType];
  const goalCategory = goalTypeConfig && goalTypeConfig.category;
  if (!goalCategory) return [];
  return GOAL_CATEGORY_TABLE_CONFIG()[goalCategory].columns;
};